import { render, staticRenderFns } from "./ShelfMonitoringDetail.vue?vue&type=template&id=126dfd94&scoped=true&"
import script from "./ShelfMonitoringDetail.vue?vue&type=script&lang=js&"
export * from "./ShelfMonitoringDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShelfMonitoringDetail.vue?vue&type=style&index=0&id=126dfd94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126dfd94",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('126dfd94')) {
      api.createRecord('126dfd94', component.options)
    } else {
      api.reload('126dfd94', component.options)
    }
    module.hot.accept("./ShelfMonitoringDetail.vue?vue&type=template&id=126dfd94&scoped=true&", function () {
      api.rerender('126dfd94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Vision/ShelfMonitoringDetail.vue"
export default component.exports